<script lang="ts">
  import CloseIconOutline from '$icons/CloseOutlineIcon.svelte';
  import Modal from '$lib/components/Modals/index.svelte';
  import HelpModalContent from '$lib/components/help/HelpModalContent.svelte';
  import { createEventDispatcher } from 'svelte';
  const d = createEventDispatcher();
  function onClose() {
    d('close');
  }
</script>

<Modal isCollapsed={false} class="w-full max-w-[360px] relative" on:ModalClose={() => onClose()}>
  <button
    class="absolute top-3 right-3 cursor-pointer"
    on:click={() => {
      onClose();
    }}
  >
    <CloseIconOutline />
  </button>

  <HelpModalContent />
</Modal>
